<template>
  <div id="RecordDetailPopup_main">
    <el-dialog
      title="詳細資訊"
      :visible.sync="dialogVisible"
      width="40%"
      @closed="handleClosePopup"
    >
      <el-tabs v-model="activeName" v-loading="loading">
        <el-tab-pane label="充電資訊" name="chargingDetail">
          <el-form label-position="left" label-width="100px" :model="data">
            <el-form-item v-for="item in chargingItemList" :key="item.name" :label="item.label">
              <div class="content">
                {{ chargingInfo ? chargingInfo[item.name] || '-' : '-' }}
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="繳費記錄" name="billDetail">
          <el-form label-position="left" label-width="100px" :model="data">
            <el-form-item v-for="item in paymentItemList" :key="item.name" :label="item.label">
              <div class="content">
                {{ paymentRecord ? paymentRecord[item.name] || '-' : '-' }}
              </div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>
<script>
import { apiEvCharging } from '@/api/EvCharging'

export default {
  data () {
    return {
      dialogVisible: false,
      data: {},
      activeName: 'chargingDetail',
      chargingItemList: [
        { label: '充電樁代碼', name: 'ConnectorSn' },
        { label: '充電樁位置', name: 'ConnectorName' },
        { label: '充電度數', name: 'ChargingKWH' },
        { label: '充電時間', name: 'ChargingDuration' },
        { label: '超時停車', name: 'IdleDuration' }
      ],
      paymentItemList: [
        { label: '繳費時間', name: 'PaySuccessTime' },
        { label: '繳費人員', name: 'PayerName' },
        { label: '繳費方式', name: 'PayMethod' }
      ],
      chargingInfo: {},
      paymentRecord: {},
      loading: false
    }
  },
  methods: {
    openDetailPopup (orderNumber) {
      this.dialogVisible = true
      this.getDetail(orderNumber)
    },
    getDetail (orderNumber) {
      if (!orderNumber) return
      this.loading = true
      apiEvCharging.Record.getRecordDetail(orderNumber).then(res => {
        this.chargingInfo = res?.data?.Data?.ChargingInfo
        this.chargingInfo.ChargingDuration = this.formatDuration(this.chargingInfo.ChargingDuration)
        this.chargingInfo.IdleDuration = this.formatDuration(this.chargingInfo.IdleDuration)
        this.chargingInfo.ChargingKWH = this.formatChargingKWH(this.chargingInfo.ChargingKWH)
        this.paymentRecord = res?.data?.Data?.PaymentRecord

        this.paymentRecord.PayMethod = this.formatPayMethod(this.paymentRecord.PayMethod)
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    formatDuration (duration) {
      if (!duration) return '-'
      const timeSplit = duration.split(':').reverse()
      const timeUnit = [this.$t('EvCharging.Second'), this.$t('EvCharging.Minute'), this.$t('EvCharging.Hour')]
      let formattedDuration = ''
      for (const i in timeSplit) {
        if (i === '2' && timeSplit[i].includes('.')) {
          const date = timeSplit[i].split('.')[0]
          const hour = timeSplit[i].split('.')[1]
          formattedDuration = `${date}${this.$t('EvCharging.Date')} ${hour}${this.$t('EvCharging.Hour')}` + formattedDuration
        } else {
          const unit = timeUnit[i] || ''
          formattedDuration = ` ${timeSplit[i]}${unit}` + formattedDuration
        }
      }

      return formattedDuration
    },
    formatChargingKWH (kWh) {
      if (typeof kWh !== 'number') { // 處理非預期拿到的資料
        if (!kWh) return '-'
        else return kWh
      }
      return `${Math.round(kWh * 100) / 100} kWh`
    },
    formatPayMethod (payMethod) {
      if (!payMethod) return '-'
      switch (payMethod) {
        case 'CreditCard':
          return '信用卡'
        case 'GooglePay':
          return 'Google Pay'
        case 'ApplePay':
          return 'Apple Pay'
        default:
          return payMethod
      }
    },
    handleClosePopup () {
      this.chargingInfo = {}
      this.paymentRecord = {}
      this.activeName = 'chargingDetail'
    }
  }
}
</script>
<style lang="scss" scoped>
#RecordDetailPopup_main {

  ::v-deep .el-dialog {
    @include basicDialog;
    min-width: 540px;
    .el-form {
      text-align: left;
      .el-form-item__label {
        margin-right: 0;
        font-weight: bold;
      }
      .el-form-item {
        margin: 0;
        padding: 10px;
        &:not(:last-child) {
          border-bottom: 1px solid $borderDark1;
        }
      }
    }
  }
}
</style>
